import { PixelCrop } from 'react-image-crop';

/**
 * Функция для отрисовки предпросмотра обрезанного изображения на canvas.
 *
 * @param image - Изображение, которое нужно обрезать.
 * @param canvas - Canvas элемент, на котором будет отрисован предпросмотр.
 * @param crop - Параметры кадрирования в пикселях.
 * @returns  Promise, который разрешается после завершения отрисовки.
 * @throws Error Если не удалось получить 2d контекст canvas.
 */
export const canvasPreview = async (
  image: HTMLImageElement,
  canvas: HTMLCanvasElement,
  crop: PixelCrop,
) => {
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    throw new Error('No 2d context');
  }

  // crop уже в натуральных пикселях изображения, масштабирование не нужно
  const canvasWidth = Math.floor(crop.width);
  const canvasHeight = Math.floor(crop.height);

  canvas.width = canvasWidth;
  canvas.height = canvasHeight;

  ctx.imageSmoothingQuality = 'high';

  ctx.drawImage(
    image,
    crop.x,
    crop.y,
    crop.width,
    crop.height,
    0,
    0,
    canvasWidth,
    canvasHeight,
  );
};
